<template>
  <div class="flex">
    <b-icon
      :icon="icon"
      size="is-small"
      class="mr-2"
      :class="iconClass"
    />
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BaseNotice',
  props: {
    icon: {
      type: String,
      default: 'exclamation-triangle',
    },
    iconClass: {
      type: String,
      default: 'has-text-danger',
    },
  },
};
</script>
